
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 486.369 486.369"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M424.096 1.493a19.405 19.405 0 00-21.186 4.189l-50.268 50.269C272.018-2.525 158.398 4.308 85.777 76.931L65.21 97.499c-15.796 15.794-15.796 41.443 0 57.239 7.897 7.897 18.266 11.846 28.602 11.846 10.371 0 20.722-3.948 28.619-11.846L143 134.169c40.946-40.962 103.353-47.486 151.304-19.845l-45.152 45.117c-5.564 5.562-7.211 13.94-4.225 21.186a19.466 19.466 0 0017.976 12.018h153.743c10.747 0 19.451-8.722 19.451-19.436V19.451c-.001-7.863-4.722-14.971-12.001-17.958zM363.939 331.64l-20.551 20.567c-23.676 23.691-55.195 36.74-88.691 36.74-22.371 0-43.796-5.94-62.648-16.86l45.169-45.186a19.411 19.411 0 004.225-21.185 19.485 19.485 0 00-17.976-11.984H69.725c-10.747 0-19.451 8.689-19.451 19.435v153.76c0 7.861 4.738 14.936 12 17.958 7.262 3.02 15.639 1.337 21.202-4.225l50.201-50.199c35.006 25.442 76.896 39.417 121.02 39.417 55.127 0 106.941-21.46 145.932-60.466l20.549-20.533c15.794-15.83 15.794-41.444 0-57.239-15.813-15.795-41.445-15.795-57.239 0z"}})])
          )
        }
      }
    